var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 1.6665C5.31669 1.6665 3.54169 3.4415 3.54169 5.62484C3.54169 7.7665 5.21669 9.49984 7.40002 9.57484C7.46669 9.5665 7.53335 9.5665 7.58335 9.57484C7.60002 9.57484 7.60835 9.57484 7.62502 9.57484C7.63335 9.57484 7.63335 9.57484 7.64169 9.57484C9.77502 9.49984 11.45 7.7665 11.4584 5.62484C11.4584 3.4415 9.68335 1.6665 7.50002 1.6665Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7334 11.7919C9.40836 10.2419 5.6167 10.2419 3.27503 11.7919C2.2167 12.5002 1.63336 13.4586 1.63336 14.4836C1.63336 15.5086 2.2167 16.4586 3.2667 17.1586C4.43336 17.9419 5.9667 18.3336 7.50003 18.3336C9.03336 18.3336 10.5667 17.9419 11.7334 17.1586C12.7834 16.4502 13.3667 15.5002 13.3667 14.4669C13.3584 13.4419 12.7834 12.4919 11.7334 11.7919Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6584 6.11659C16.7917 7.73325 15.6417 9.14992 14.05 9.34159C14.0417 9.34159 14.0417 9.34159 14.0334 9.34159H14.0084C13.9584 9.34159 13.9084 9.34159 13.8667 9.35825C13.0584 9.39992 12.3167 9.14159 11.7584 8.66659C12.6167 7.89992 13.1084 6.74992 13.0084 5.49992C12.95 4.82492 12.7167 4.20825 12.3667 3.68325C12.6834 3.52492 13.05 3.42492 13.425 3.39159C15.0584 3.24992 16.5167 4.46659 16.6584 6.11659Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.325 13.8252C18.2583 14.6335 17.7417 15.3335 16.875 15.8085C16.0417 16.2668 14.9917 16.4835 13.95 16.4585C14.55 15.9168 14.9 15.2418 14.9667 14.5252C15.05 13.4918 14.5583 12.5002 13.575 11.7085C13.0167 11.2668 12.3667 10.9168 11.6583 10.6585C13.5 10.1252 15.8167 10.4835 17.2417 11.6335C18.0083 12.2502 18.4 13.0252 18.325 13.8252Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User1);
export default __webpack_public_path__ + "static/media/profile-2user (1).ded12f29b7641d0bf24646e66609bc7b.svg";
export { ForwardRef as ReactComponent };